import { Link, Text } from '@billy/design-system'
import { ReactElement, useMemo } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { SupportedCountries } from '../../../types/supportedCountries'
import { isSupportedCountryId, shouldUseDKReportContent } from '../../../utils/isSupportedCountryId'

export const useVatDeclarationsCorrectionMessage = () => {
  const { organization } = useUserOrganization()
  const { t } = useTranslation()

  const link = t('here')

  const countryCorrectionMessage = useMemo(() => {
    if (!organization?.countryId || !isSupportedCountryId(organization.countryId)) {
      return null
    }

    const messages: Partial<Record<SupportedCountries, ReactElement>> = {
      DK: (
        <Trans i18nKey="vat_declarations.correction_banner.description_dk" values={{ link }}>
          You have previously reported VAT for one or more periods. Since then, changes have been made to your
          bookkeeping, which affect your VAT declaration. You need to submit a correction for the period to SKAT. Learn
          how to submit the correction
          <Link href="https://www.billy.dk/support/article/ret-din-momsopgoerelse-hos-skat/" target="_blank">
            {link}
          </Link>
        </Trans>
      ),
      DE: <Text>{t('vat_declarations.correction_banner.description_de')}</Text>,
      FR: <Text>{t('vat_declarations.correction_banner.description_fr')}</Text>,
      NL: <Text>{t('vat_declarations.correction_banner.description_nl')}</Text>,
    }

    return shouldUseDKReportContent(organization.countryId) ? messages.DK : messages[organization.countryId]
  }, [organization?.countryId, link, t])

  return { countryCorrectionMessage }
}
